import React from "react";

export default function GoogleFile() {
  return (
    <>
      <div>google-site-verification: googleb965e3c8883b9329.html</div>
    </>
  );
}
